module.exports = __webpack_public_path__ + "static/media/white_tinted_oak.4e3b84ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/interiorColors/white_tinted_oak.jpg
// module id = 87
// module chunks = 0